.viewport {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: var(--color-bg);
  color: var(--color-text);
  font-family: var(--font-body);
}

/*
 * Fixed 1280×800 design canvas, scaled to fit. The transform also makes the stage the containing
 * block for position:fixed overlays (hazard frames, dialogs), so they cover the stage, not the
 * letterbox around it.
 */
.stage {
  position: relative;
  flex: none;
  transform-origin: center center;
}

.content {
  position: absolute;
  top: 65px;
  bottom: 53px;
  left: 0;
  right: 0;
  overflow: hidden;
}

.topBar,
.bottomBar {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background: var(--color-surface);
}
.topBar {
  top: 0;
  height: 64px;
  box-shadow: var(--shadow-bar);
  animation: evx-barTop 0.8s cubic-bezier(0.2, 0.7, 0.2, 1) 0.3s both;
}
.bottomBar {
  bottom: 0;
  height: 52px;
  box-shadow: 0 -2px 10px rgba(26, 32, 44, 0.06);
  animation: evx-barBot 0.8s cubic-bezier(0.2, 0.7, 0.2, 1) 0.5s both;
}

.group {
  display: flex;
  align-items: center;
}
.brand {
  gap: 18px;
}
.logo {
  height: 36px;
  width: auto;
}
.unitLabel {
  font-size: 12px;
  letter-spacing: 0.03em;
  color: var(--color-neutral-700);
  font-weight: 600;
}
.unitChip {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.02em;
  background: var(--color-accent-100);
  color: var(--color-accent-700);
  padding: 5px 12px;
  border-radius: var(--radius-sm);
}
.divider {
  width: 1px;
  height: 20px;
  background: var(--color-divider);
}
.statusGroup .divider {
  height: 16px;
}
.hospital {
  display: flex;
  align-items: center;
  gap: 9px;
  font-family: var(--font-heading);
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
}
.operator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  color: var(--color-text);
}
.signOut {
  margin-left: 6px;
  background: var(--color-neutral-100);
  border: none;
  border-radius: var(--radius-sm);
  padding: 7px 14px;
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-neutral-700);
  cursor: pointer;
}
.signOut:hover {
  background: var(--color-accent-100);
  color: var(--color-accent-700);
}
.hospitalIcon {
  color: var(--color-accent);
}

.statusGroup {
  gap: 20px;
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-neutral-700);
}
.link {
  display: flex;
  align-items: center;
  gap: 7px;
}
.linkDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-accent);
  animation: evx-pulse 2s infinite;
}
.offline .linkDot {
  background: var(--color-danger);
}
.clock {
  font-variant-numeric: tabular-nums;
  color: var(--color-text);
  font-weight: 700;
}
.themeToggle {
  display: flex;
  align-items: center;
  gap: 7px;
  background: var(--color-neutral-100);
  border: none;
  border-radius: var(--radius-sm);
  padding: 8px 14px;
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-neutral-700);
  cursor: pointer;
}
.themeToggle:hover {
  background: var(--color-accent-100);
  color: var(--color-accent-700);
}

.steps {
  display: flex;
  align-items: center;
  gap: 22px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.step {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-neutral-500);
  opacity: 0.5;
}
.stepDone {
  opacity: 0.8;
}
.stepCurrent {
  color: var(--color-text);
  font-weight: 800;
  opacity: 1;
}
.footerMeta {
  gap: 14px;
  font-size: 11px;
  color: var(--color-neutral-600);
  font-weight: 600;
}
.demoTag {
  background: var(--color-neutral-100);
  color: var(--color-neutral-700);
  padding: 3px 10px;
  border-radius: var(--radius-sm);
}
